<template>
  <div class="warehousingPage">
    <div class="main_content">
      <div class="goods_desciption">
        <p class="txt1 fontSize-blueColor-md">品牌（出版商）：</p>
        <p class="txt1 fontSize-blueColor-md">
          属性标签：{{ pDetail.TagValues }}
        </p>
        <p class="txt1 fontSize-blueColor-md">属性值： {{ pDetail.Tags }}</p>
        <p class="txt1 fontSize-blueColor-md">
          采购数量： {{ pDetail.Quantity }}
        </p>
        <p class="txt1 fontSize-blueColor-md">采购金额：{{ pDetail.Amount }}</p>
        <p class="txt1 fontSize-blueColor-md">
          已入库数量：{{ pDetail.QuantityReceived }}
        </p>
        <p class="txt1 fontSize-blueColor-md">
          付款形式：{{ pDetail.PaymentMethod }}
        </p>
      </div>

      <div class="data_list">
        <div class="item_card" v-for="item in dataList" :key="item.id">
          <div class="txt1">入库记录：{{ item.ID }}</div>
          <div class="txt1">入库数量：{{ item.InventoryQuantity }}</div>
          <div class="txt1">物流类型：{{ item.LogisticsType }}</div>
          <div class="txt1">物流单号：{{ item.LogisticsNumber }}</div>
          <div class="txt1">预计到货时间：{{ item.EstimatedArrivalTime }}</div>
          <div class="txt1">入库商品批次记录：{{ item.ProductionBatch }}</div>
          <div class="txt1">入库商品生产商记录：{{ item.Manufacturer }}</div>
          <div class="operaton flex-rowr">
            <div
              class="operation_item"
              :class="{ active: item.InventoryStatus == 0 }"
            >
              {{ item.InventoryStatus == 0 ? "待入库" : "已入库" }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="return-fixd">
      <div class="primary-button" @click="handleGo" v-if="rkjhAuth.isViewrange">
        添加入库计划
      </div>
      <!-- <div class="default-button return" @click="handleReturn">←返回</div> -->
    </div>
    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>
  </div>
</template>

<script>
import { getMenuAuthThree, getPurchaseDetail } from "../../api/api";
import storage from "../../utils/storage";
export default {
  name: "pWareList",
  data() {
    return {
      // 添加入库计划权限
      rkjhAuth: "",

      id: "", // 采购记录id
      detail: "",

      pDetail: "",
      dataList: [],
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.getInit();
    this.getMenuAuthThree();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthThree() {
      let menuItem = this.$store.state.menuItem;
      let roleId = this.$store.state.USERINFO.qy.roleid;
      getMenuAuthThree(menuItem.id).then((res) => {
        if (res.length === 0) return;
        res.forEach((item) => {
          if (item.funcname === "添加入库计划") {
            // 是否预览权限
            item.isViewrange = item.viewrange.split(",").indexOf(roleId) != -1;
            // 是否操作权限
            item.isDorange = item.dorange.split(",").indexOf(roleId) != -1;
            this.rkjhAuth = item;
          }
        });
      });
    },

    async getInit() {
      let id = this.$route.params.id;
      this.detail = storage.get("GOODDETAIL");
      let res1 = await getPurchaseDetail({ id });
      this.pDetail = res1;
      if (res1.log.length > 0) {
        this.dataList = res1.log;
      }
    },

    handleReturn() {
      history.back();
    },

    handleGo() {
      let { rkjhAuth } = this;
      if (!rkjhAuth.isDorange) {
        this.$message.warning("暂无权限");
        return;
      }
      this.$router.push(`${rkjhAuth.pagepath}/${this.id}`);
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingPage {
  //   .my-swipe {
  //     width: 750px;
  //     height: 750px;
  //     background: #eeeeee;
  //   }
  .main_content {
    padding: 80px 0 460px;
    width: 650px;
    margin: auto;
    .txt3 {
      font-size: 28px !important;
    }
    .data_list {
      margin-top: 90px;
      .item_card {
        width: 650px;
        margin: 0 auto 40px;
        padding: 45px 37px 47px;
        position: relative;
        border: 2px solid #dedede;
        border-radius: 30px;
        box-sizing: border-box;
        .title {
          font-size: 30px;
          color: #404d6c;
          p {
            font-size: 22px;
            margin-top: 20px;
          }
        }
        .img {
          width: 250px;
          height: 250px;
          margin: 80px auto 50px;
          overflow: hidden;
          background: #fbf8ef;
          img {
            width: 100%;
          }
        }
        .txt1 {
          font-size: 26px;
          color: #404d6c;
          margin-bottom: 10px;
        }
        .txt2 {
          font-size: 26px;
          color: #444444;
          font-weight: bold;
          margin-bottom: 10px;
          span {
            font-size: 26px;
            color: #f40728;
            font-weight: 400;
          }
        }
        .operaton {
          margin-top: 40px;
          .operation_item {
            padding: 10px 30px;
            border-radius: 45px;
            border: 1px solid #dedede;
            font-size: 24px;
            margin-left: 30px;
            color: #404d6c;
            &.active {
              color: #f62560;
            }
          }
        }
      }
    }
  }
  .btn_group {
    margin-top: 89px;
    .btn1 {
      margin-bottom: 57px;
    }
  }
}
</style>